import { AxiosResponse } from "axios";
import { http } from "@/utils/http";
import {
  INewProvider,
  IUpdateProvider,
} from "@/features/provider/provider.types";

export const providerService = {
  getList: async (): Promise<AxiosResponse> => {
    return http.get("/eld/providers");
  },

  createProvider: async (payload: INewProvider): Promise<AxiosResponse> => {
    return http.post("/eld/providers", payload);
  },

  updateProvider: async (
    payload: IUpdateProvider,
    id: string
  ): Promise<AxiosResponse> => {
    return http.patch(`/eld/providers/${id}`, payload);
  },
};
